import {Component, Input, OnInit} from '@angular/core';
import {Device} from "../../model/device.model";
import {DeviceService} from "../device.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {UtilService} from "../../shared/util.service";
import {MeasureModel} from "../../model/measure.model";
import {DatapointModel} from "../../model/datapoint.model";
import {DatapointDialogComponent} from "../datapoint-dialog/datapoint-dialog.component";

@Component({
    selector: 'app-device-manage',
    templateUrl: './device-manage.component.html',
    standalone: false
})
export class DeviceManageComponent implements OnInit {

  @Input() device: Device;
  measures: MeasureModel[];

  constructor(
    private service: DeviceService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private util: UtilService
  ) { }

  ngOnInit(): void {
    this.fetchOptions();
  }

  fetchOptions() {
    this.service.getMeasures().subscribe((resp:any) => {
      if (resp.length) {
        this.measures = resp.map(r => new MeasureModel(r));
      }
    })
  }

  onClickDialogBtn(datapoint?) {
    let isEdit = datapoint && datapoint.id;
    const dialogRef = this.dialog.open(DatapointDialogComponent, {
      data: {
        item: datapoint ? Object.assign(new DatapointModel(), datapoint) : new DatapointModel({device: this.device.id}),
        isEdit: isEdit,
        measures: this.measures
      },
      minWidth: '300px',
      maxWidth: '500px'
    });

    dialogRef.afterClosed().subscribe( (result: DatapointModel) => {
      if (result) {
        if (isEdit) {
          this.device.datapointList = this.util.findAndReplaceItemInArray(result, this.device.datapointList);
        } else {
          this.device.datapointList.push(result);
        }
      }
    });
  }

  onDeleteDatapointClick(datapoint) {
    this.service.confirmAction().subscribe((isConfirm: boolean) => {
      if (isConfirm) {
        this.deleteDatapoint(datapoint);
      }
    })
  }

  deleteDatapoint(datapoint) {
    this.service.deleteDatapoint(datapoint.id).subscribe((resp:any) => {
      if (resp.success) {
        this.service.notiService.open("Deleted");
        this.util.findAndReplaceItemInArray(datapoint, this.device.datapointList, true);
      }
    })
  }

  onEditDatapointClick(datapoint) {
    this.onClickDialogBtn(datapoint);
  }
}
